import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackAskQuestionClickedItemPage = () =>
    useTrackConversion({ goal: KameleoonGoalData.AskQuestionClickedItemPage });
